module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./indexView.js"));
	}, "PayFormView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=PayFormView!./src/pages/Shop/PayMent/PayForm/indexView.js
// module id = 1371
// module chunks = 418